const SeriesData = [
    {
        image: "images/breakingBad.jpg",
        category: "AMC Original Series",
        title: "Breaking Bad",
        link: "https://www.netflix.com/in/title/70143836"
    },
    {
        image: "images/strangerThings.jpg",
        category: "Neflix Original Series",
        title: "Stranger Things",
        link: "https://www.netflix.com/in/title/80057281"
    },
    {
        image: "images/dark.jpg",
        category: "Netflix Original Series",
        title: "Dark",
        link: "https://www.netflix.com/in/title/80100172"
    },
    {
        image: "images/prisonBreak.jpg",
        category: "Fox Original Series",
        title: "Prison Break",
        link: "https://www.hotstar.com/in/tv/prison-break/8536?utm_source=gwa"
    },
    {
        image: "images/lost.jpg",
        category: "ABC Original Series",
        title: "LOST",
        link: "https://www.amazon.com/Lost-Season-1/dp/B003U4XNKC"
    },
    {
        image: "images/mrRobot.jpg",
        category: "USA Original Series",
        title: "Mr. Robot",
        link: "https://www.amazon.com/Mr-Robot-Season-1/dp/B00YBX664Q"
    },
    {
        image: "images/betterCallSaul.jpg",
        category: "AMC Original Series",
        title: "Better Call Saul",
        link: "https://www.netflix.com/in/title/80021955"
    },
    {
        image: "images/mindHunter.jpg",
        category: "Netflix Original Series",
        title: "MindHunter",
        link: "https://www.netflix.com/in/title/80114855"
    },
    {
        image: "images/chernobyl.jpg",
        category: "HBO Mini Series",
        title: "Chernobyl",
        link: "https://www.hotstar.com/in/tv/chernobyl/1260004866"
    },
    {
        image: "images/sherlock.jpg",
        category: "BBC Original Series",
        title: "Sherlock",
        link: "https://www.netflix.com/in/title/70202589"
    }
]

export default SeriesData;